// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export var _DYN_REQUEST_URL = "requestUrl"; // Count: 10
export var _DYN_LENGTH = "length"; // Count: 9
export var _DYN_ABORTED = "aborted"; // Count: 5
export var _DYN_TRACE_ID = "traceId"; // Count: 11
export var _DYN_SPAN_ID = "spanId"; // Count: 10
export var _DYN_TRACE_FLAGS = "traceFlags"; // Count: 7
export var _DYN_TRACE_STATE = "traceState"; // Count: 3
export var _DYN_CONTEXT = "context"; // Count: 4
export var _DYN__ADD_HOOK = "_addHook"; // Count: 4
export var _DYN_CORE = "core"; // Count: 7
export var _DYN_INCLUDE_CORRELATION_0 = "includeCorrelationHeaders"; // Count: 4
export var _DYN_GET_ABSOLUTE_URL = "getAbsoluteUrl"; // Count: 4
export var _DYN_HEADERS = "headers"; // Count: 7
export var _DYN_REQUEST_HEADERS = "requestHeaders"; // Count: 15
export var _DYN_SET_REQUEST_HEADER = "setRequestHeader"; // Count: 4
export var _DYN_TRACK_DEPENDENCY_DAT1 = "trackDependencyDataInternal"; // Count: 2
export var _DYN_START_TIME = "startTime"; // Count: 5
export var _DYN_TO_LOWER_CASE = "toLowerCase"; // Count: 6
export var _DYN_ENABLE_REQUEST_HEADE2 = "enableRequestHeaderTracking"; // Count: 3
export var _DYN_ENABLE_AJAX_ERROR_ST3 = "enableAjaxErrorStatusText"; // Count: 2
export var _DYN_ENABLE_AJAX_PERF_TRA4 = "enableAjaxPerfTracking"; // Count: 2
export var _DYN_MAX_AJAX_CALLS_PER_V5 = "maxAjaxCallsPerView"; // Count: 2
export var _DYN_EXCLUDE_REQUEST_FROM6 = "excludeRequestFromAutoTrackingPatterns"; // Count: 2
export var _DYN_DISABLE_AJAX_TRACKIN7 = "disableAjaxTracking"; // Count: 3
export var _DYN_AJAX_PERF_LOOKUP_DEL8 = "ajaxPerfLookupDelay"; // Count: 2
export var _DYN_DISABLE_FETCH_TRACKI9 = "disableFetchTracking"; // Count: 2
export var _DYN_ENABLE_RESPONSE_HEAD10 = "enableResponseHeaderTracking"; // Count: 2
export var _DYN_STATUS = "status"; // Count: 10
export var _DYN_STATUS_TEXT = "statusText"; // Count: 7
export var _DYN_HEADER_MAP = "headerMap"; // Count: 5
export var _DYN_REQUEST_SENT_TIME = "requestSentTime"; // Count: 9
export var _DYN_METHOD = "method"; // Count: 7
export var _DYN_ERROR_STATUS_TEXT = "errorStatusText"; // Count: 3
export var _DYN_STATE_CHANGE_ATTACHE11 = "stateChangeAttached"; // Count: 2
export var _DYN_RESPONSE_TEXT = "responseText"; // Count: 7
export var _DYN_RESPONSE_FINISHED_TI12 = "responseFinishedTime"; // Count: 7
export var _DYN__CREATE_TRACK_ITEM = "CreateTrackItem"; // Count: 3
export var _DYN_GET_ALL_RESPONSE_HEA13 = "getAllResponseHeaders"; // Count: 2
export var _DYN_PERF_TIMING = "perfTiming"; // Count: 3
export var _DYN_AJAX_DIAGNOSTICS_MES14 = "ajaxDiagnosticsMessage"; // Count: 3
export var _DYN_CORRELATION_CONTEXT = "correlationContext"; // Count: 3
export var _DYN_AJAX_TOTAL_DURATION = "ajaxTotalDuration"; // Count: 3
//# sourceMappingURL=__DynamicConstants.js.map